import { Directive, ElementRef, Input, OnInit, OnChanges } from '@angular/core';

@Directive({ selector: '[set-aspect-ratio]' })
export class SetAspectRatioDirective implements OnInit {
    @Input("set-aspect-ratio") item: any;

    private el: ElementRef
    constructor(el: ElementRef) {
        this.el = el
    }

    ngOnChanges() {
        if (!this.el.nativeElement.classList) {
            return
        }
    
        var className = "";
        let imageSize = this.item;
        if (imageSize) {
            let aspect = imageSize.width / imageSize.height;
            className = aspect > 1 ? "landscape" : aspect === 0 ? "square" : "portrait";
        }
        this.el.nativeElement.classList.add(className)
    }

    ngOnInit() {

    }
}



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-directives/set-aspect-ratio.directive.ts